import { NavMarker } from 'react-rhumb';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import UISection from 'UIComponents/section/UISection';
import { OLAF } from 'HubStyleTokens/colors';
import ApiError from '../../../components/Errors/ApiError';
import NoResultsError from '../../../components/Errors/NoResultsError';
// @ts-expect-error Could not find a declaration file for module
import FavoriteChangeContext from '../../../contexts/FavoriteChangeContext';
// @ts-expect-error Could not find a declaration file for module
import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import ResultsStatusBar from '../../../components/ResultsStatusBar';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { MY_SAVED_ITEMS_PAGE_SIZE, SavedItemsEmpty } from '../../../features/savedItems';
import { TopFilters } from '../../filters';
import { safeSmoothScrollTo } from '../../../utils/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CatalogPageWrapper = styled.div.withConfig({
  displayName: "SavedItemsPagedList__CatalogPageWrapper",
  componentId: "sc-1xop5l1-0"
})(["[class^='UIAbstractPageTemplate'] > section + div{border-top:0;}"]);
const SavedItemsPagedList = ({
  totalCount,
  hasItems,
  error,
  isRequesting,
  hasError,
  markerKey,
  itemKey,
  list,
  navigation,
  filters,
  page,
  isLoadingPageOnDemand,
  alwaysShowFilters,
  alwaysShowResultsStatusBar,
  mobileFilters,
  mobileResultsActions,
  hideFilterLabel
}) => {
  const location = useLocation();
  const history = useHistory();
  const {
    isMobile
  } = useMediaQuery();
  const favoriteChangeContext = {
    showUnfavoriteedMsg: true
  };
  const handlePageChange = pageNumber => {
    history.push(Object.assign({}, location, {
      pathname: location.pathname.replace(/(\/page\/\d+)|$/, `/page/${pageNumber}`)
    }));
    safeSmoothScrollTo(window, 0, 0);
  };
  return /*#__PURE__*/_jsxs(CatalogPageWrapper, {
    children: [(hasItems || totalCount || isMobile || alwaysShowResultsStatusBar) && /*#__PURE__*/_jsx(ResultsStatusBar, {
      cardsTotal: totalCount,
      endCard: Math.min((page || 1) * MY_SAVED_ITEMS_PAGE_SIZE, totalCount),
      mobileFilterTypes: mobileFilters || filters,
      mobileResultsActions: mobileResultsActions,
      startCard: !page ? 1 : (page - 1) * MY_SAVED_ITEMS_PAGE_SIZE + 1
    }), /*#__PURE__*/_jsx(UIDashboardPage, {
      headerComponent: null,
      mainSectionStyle: {
        backgroundColor: OLAF
      },
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: `${markerKey}_LISTING_LOADED`
        }), navigation, (hasItems || totalCount || alwaysShowFilters) && filters && /*#__PURE__*/_jsx(TopFilters, {
          enabledFilters: filters,
          showClearButton: false // TODO: Remove this once `enabledFilters` grows past only search
          ,
          showLabel: !hideFilterLabel
        }), isRequesting ? /*#__PURE__*/_jsx(UISection, {
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            grow: true,
            minHeight: 100
          })
        }) : hasError ? /*#__PURE__*/_jsx(ApiError, {
          className: "tracks-api-error",
          error: error,
          marker404: `${markerKey}_LISTING_API_404`,
          markerDefault: `${markerKey}_LISTING_API_ERROR`
        }) : !totalCount ? !hasItems ? /*#__PURE__*/_jsx(SavedItemsEmpty, {
          itemKey: itemKey
        }) : /*#__PURE__*/_jsx(NoResultsError, {
          resetLink: location.pathname
        }) : /*#__PURE__*/_jsx(FavoriteChangeContext.Provider, {
          value: favoriteChangeContext,
          children: /*#__PURE__*/_jsx(PaginatedUICardGrid, {
            isLoadingPageOnDemand: isLoadingPageOnDemand,
            limit: MY_SAVED_ITEMS_PAGE_SIZE,
            onPageChange: handlePageChange,
            page: page,
            totalCount: totalCount,
            children: list
          })
        })]
      })
    })]
  });
};
export default SavedItemsPagedList;